module.exports = {"query_editor":{"nav_title":"Query Editor"}}